import { Button, Color, Flex, Icon, IconButton, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useOpenBankingAutoConnectModal } from '../../contexts/openBankingAutoConnectContext'
import * as Styled from '../LoadingModalBody/styles'

export const ErrorModalBody = (): ReactElement => {
  const { t } = useTranslation()
  const { handleCloseModal } = useOpenBankingAutoConnectModal()

  return (
    <Flex flexDirection="column" alignItems="center">
      <Styled.CloseButtonRow>
        <IconButton icon="x" onClick={handleCloseModal} />
      </Styled.CloseButtonRow>
      <Space size="s32" />
      <Styled.IconWrapper isLoading={false}>
        <Icon icon="circleX" color={Color.Red600} />
      </Styled.IconWrapper>
      <Space size="s40" />
      <Text weight="medium" variant="h3" alignment="center">
        {t('bank_connection.open_banking_auto_connect_modal.error_title')}
      </Text>
      <Space size="s8" />
      <Text variant="bodyLG" colorVariant="discreet" alignment="center">
        {t('bank_connection.open_banking_auto_connect_modal.error_description')}
      </Text>
      <Space size="s32" />
      <Button onClick={handleCloseModal}>{t('close')}</Button>
    </Flex>
  )
}
